import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

// Fix default marker icon (leaflet + webpack)
const icon = new L.DivIcon({
  html: `<div style="background:#1A362D;color:#fff;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.3);width:32px;height:32px;display:grid;place-items:center;font-family:'Outfit',sans-serif;font-weight:900;font-size:14px;transform:translate(-50%,-100%)">FX</div>`,
  className: "",
  iconSize: [32, 32],
  iconAnchor: [0, 0],
});

const PLACEHOLDER = "https://images.unsplash.com/photo-1572521165329-b197f9ea3da6?crop=entropy&cs=srgb&fm=jpg&w=200&q=60&ixlib=rb-4.1.0";
const UK_CENTER = [54.5, -2.5];

export default function MapView({ listings }) {
  const [marked, setMarked] = useState([]);

  useEffect(() => {
    const withPc = listings.filter((l) => l.postcode);
    if (withPc.length === 0) { setMarked([]); return; }
    const codes = withPc.map((l) => l.postcode);
    (async () => {
      try {
        const res = await fetch("https://api.postcodes.io/postcodes", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ postcodes: codes }),
        });
        const j = await res.json();
        const byPc = {};
        (j.result || []).forEach((r) => {
          if (r.result && r.query) byPc[r.query.toUpperCase()] = r.result;
        });
        const out = withPc
          .map((l) => {
            const r = byPc[(l.postcode || "").toUpperCase()];
            return r ? { ...l, latitude: r.latitude, longitude: r.longitude } : null;
          })
          .filter(Boolean);
        setMarked(out);
      } catch {
        setMarked([]);
      }
    })();
  }, [listings]);

  return (
    <div className="border border-border bg-white overflow-hidden" style={{ height: "70vh" }}>
      <MapContainer center={UK_CENTER} zoom={6} scrollWheelZoom={true} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {marked.map((l) => (
          <Marker key={l.listing_id} position={[l.latitude, l.longitude]} icon={icon}>
            <Popup>
              <div className="w-52">
                <img
                  src={l.images?.[0] ? fileUrl(l.images[0]) : PLACEHOLDER}
                  alt=""
                  className="w-full h-24 object-cover mb-2"
                />
                <div className="font-display text-sm leading-tight line-clamp-2">{l.title}</div>
                <div className="mt-1 text-forest font-display tabular-nums">£{Number(l.price).toFixed(2)}</div>
                <Link to={`/listings/${l.listing_id}`} className="mt-2 inline-block text-xs text-safety overline">View →</Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      {marked.length === 0 && (
        <div className="absolute inset-0 pointer-events-none grid place-items-center bg-white/40">
          <div className="border border-border bg-white p-6 text-center pointer-events-auto">
            <div className="overline text-muted-foreground">Map view</div>
            <div className="font-display text-lg tracking-tight mt-1">No mappable listings yet</div>
            <p className="text-sm text-muted-foreground mt-1">Add postcodes to listings to see them here.</p>
          </div>
        </div>
      )}
    </div>
  );
}
